import*as React from'react';/**
 * @ignore - internal component.
 */const FormControlContext=/*#__PURE__*/React.createContext();if(process.env.NODE_ENV!=='production'){FormControlContext.displayName='FormControlContext';}export default FormControlContext;